import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_578c5184 from '../styles/Heading.module.less.js';

/**
 * @description The Heading component is used for all headings.
 *
 * @component
 * @example
 * ```jsx
 * <Heading level={2}>
 *   Heading
 * </Heading>
 * ```
 */
const Heading = React.forwardRef((props, ref) => {
    const { as, level, className, children, ...restProps } = props;
    const cx = useStyles(modules_578c5184);
    const classNames = cx(className, 'container', {
        [`size-${level}`]: level,
    });
    return React.createElement(as || `h${level}`, {
        ref,
        className: classNames,
        ...restProps,
    }, children);
});
Heading.defaultProps = {
    level: 1,
};
Heading.displayName = 'Heading';

export { Heading };
//# sourceMappingURL=Heading.js.map
